export const VIEW = Object.freeze({
    DAY:      'day',
    WEEK:     'week',
    MONTH:    'month',
    SCHEDULE: 'schedule',
    YEAR:     'year',
});

export const PERIOD = Object.freeze({
    DAYS:   'days',
    MONTHS: 'months',
    YEARS:  'years',
});

export const PERIOD_LEVELS = Object.freeze({
    [PERIOD.DAYS]:   1,
    [PERIOD.MONTHS]: 3,
    [PERIOD.YEARS]:  5,
});

export const VIEW_LEVELS = Object.freeze({
    [VIEW.DAY]:      1,
    [VIEW.WEEK]:     1,
    [VIEW.MONTH]:    3,
    [VIEW.SCHEDULE]: 3,
    [VIEW.YEAR]:     5,
});
